function normalizeId(value) {
  if (!value) return "";
  if (typeof value === "object" && value?.$oid) return String(value.$oid);
  return String(value);
}

function syncSelectedPatientFromList(currentSelectedPatient, nextPatients) {
  if (!currentSelectedPatient) return currentSelectedPatient;
  if (!Array.isArray(nextPatients) || nextPatients.length === 0) return currentSelectedPatient;

  const currentId = normalizeId(
    currentSelectedPatient?._id ||
      currentSelectedPatient?.userID ||
      currentSelectedPatient?.id
  );
  if (!currentId) return currentSelectedPatient;

  return (
    nextPatients.find((patient) => {
      const patientId = normalizeId(patient?._id || patient?.userID || patient?.id);
      return patientId === currentId;
    }) || currentSelectedPatient
  );
}

module.exports = {
  syncSelectedPatientFromList,
};
